import { configServices } from 'src/services';
import { currentOrigin } from 'src/app-config';
import { FC } from 'react';
import { hideLoadingModalReducer, setAlertResponse, showLoadingModalReducer } from 'src/store';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useGetConfig, useGetIsDarkMode, useGetIsMobile } from 'src/custom-hooks';

type propsType = {
    closeModal: () => void;
};

export const AVUshersSettings: FC<propsType> = ({ closeModal }) => {
    const config = useGetConfig();
    const dispatch = useDispatch();
    const isDarkMode = useGetIsDarkMode();
    const isMobile = useGetIsMobile();

    const setIsEnabledPublicPage = async () => {
        dispatch(showLoadingModalReducer());
        const response = await configServices.SetAVUshersIsEnabledPublicPage(!config.isEnabledAvUshersPublicPage);
        dispatch(hideLoadingModalReducer());
        if (!response.success) {
            dispatch(setAlertResponse({ response }));
            return;
        }
        window.location.reload();
    }

    return (
        <Modal show fullscreen onHide={closeModal}>
            <Modal.Header className={`${isDarkMode ? 'bg-lightdark text-white' : ''} border`} closeButton>
                <Modal.Title>
                    OPCIONES DE AUDIO Y VIDEO Y ACOMODADORES
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className={isDarkMode ? 'bg-dark text-white' : ''}>
                <div className={`container card ${isDarkMode ? 'bg-lightdark text-white' : ''} border py-2 pb-3 mt-0`}>
                    <div className={'row d-flex justify-content-start align-items-center'} style={{ marginTop: '14px' }}>
                        <div className={`${isMobile ? 'col-2' : 'col-3'} text-end`}>
                            <input type='checkbox'
                                className={'form-check-input checkbox-md pointer'}
                                checked={!!config.isEnabledAvUshersPublicPage}
                                onChange={setIsEnabledPublicPage}
                            />
                        </div>
                        <div className={'col'}>
                            <h5 className={`d-inline ${isDarkMode ? 'text-white' : ''} pt-2`}>
                                <span className={'c-pointer me-2'} onClick={setIsEnabledPublicPage}>
                                    Habilitar página pública de Audio y Video y Acomodadores
                                </span>
                                {config.isEnabledAvUshersPublicPage &&
                                    <>
                                    <br />
                                    (<a href={`${currentOrigin}/audio-video-acomodadores/${config.congregation}`} target={'_blank'}>{`${currentOrigin}/audio-video-acomodadores/${config.congregation}`}</a>)
                                    </>
                                }
                            </h5>
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
}
